Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typeValidation = require('./typeValidation');

var _typeValidation2 = _interopRequireDefault(_typeValidation);

require('@pcty/pager/lib/css/index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PctyPager = function (_Component) {
  _inherits(PctyPager, _Component);

  function PctyPager(props) {
    _classCallCheck(this, PctyPager);

    var _this = _possibleConstructorReturn(this, (PctyPager.__proto__ || Object.getPrototypeOf(PctyPager)).call(this, props));

    var _this$props = _this.props,
        numberOfVisiblePages = _this$props.numberOfVisiblePages,
        page = _this$props.page,
        pageSize = _this$props.pageSize,
        itemCount = _this$props.itemCount;

    var pageCount = calcPageCount(itemCount, pageSize);

    _this.state = {
      visiblePages: _this.getVisiblePages(numberOfVisiblePages, page, pageCount),
      page: _this.props.page,
      pageCount: pageCount,
      props: props
    };

    _this.goToPage = _this.goToPage.bind(_this);
    _this.goToFirstPage = _this.goToFirstPage.bind(_this);
    _this.goBackAPageRange = _this.goBackAPageRange.bind(_this);
    _this.goBackAPage = _this.goBackAPage.bind(_this);
    _this.goForwardAPage = _this.goForwardAPage.bind(_this);
    _this.goForwardAPageRange = _this.goForwardAPageRange.bind(_this);
    _this.goToLastPage = _this.goToLastPage.bind(_this);
    return _this;
  }

  _createClass(PctyPager, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'pcty-pager', id: this.props.id },
        this.renderFirst(),
        this.renderPrevious(),
        _react2.default.createElement(
          'ul',
          { className: 'pcty-pager-list' },
          this.renderBackElipses(),
          this.renderPageLinks(),
          this.renderForwardElipses()
        ),
        this.renderNext(),
        this.renderLast(),
        this.renderPageRange()
      );
    }
  }, {
    key: 'renderFirst',
    value: function renderFirst() {
      var _this2 = this;

      if (this.props.itemCount <= 0) return null;

      var page = this.state.page;


      if (page === 1 || this.props.disabled) {
        return _react2.default.createElement(
          'a',
          _extends({ className: 'pcty-pager-control pcty-disabled', title: 'Go to the first page' }, this.automationTag('first')),
          _react2.default.createElement('i', { className: 'pcty-pager-icon-first' })
        );
      }

      if (page > 1) {
        return _react2.default.createElement(
          'a',
          _extends({ className: 'pcty-pager-control', onClick: function onClick() {
              return _this2.goToFirstPage();
            }, title: 'Go to the first page' }, this.automationTag('first')),
          _react2.default.createElement('i', { className: 'pcty-pager-icon-first' })
        );
      }
    }
  }, {
    key: 'renderPrevious',
    value: function renderPrevious() {
      var _this3 = this;

      if (this.props.itemCount <= 0) return null;

      var page = this.state.page;


      if (page === 1 || this.props.disabled) {
        return _react2.default.createElement(
          'a',
          _extends({ className: 'pcty-pager-control pcty-disabled', title: 'Go to the previous page' }, this.automationTag('prev')),
          _react2.default.createElement('i', { className: 'pcty-pager-icon-back' })
        );
      }

      return _react2.default.createElement(
        'a',
        _extends({ className: 'pcty-pager-control', onClick: function onClick() {
            return _this3.goBackAPage();
          }, title: 'Go to the previous page' }, this.automationTag('prev')),
        _react2.default.createElement('i', { className: 'pcty-pager-icon-back' })
      );
    }
  }, {
    key: 'renderNext',
    value: function renderNext() {
      var _this4 = this;

      var itemCount = this.props.itemCount;
      var pageCount = this.state.pageCount;


      if (itemCount <= 0) return null;

      var page = this.state.page;


      if (page === pageCount || this.props.disabled) {
        return _react2.default.createElement(
          'a',
          _extends({ className: 'pcty-pager-control pcty-disabled', title: 'Go to the next page' }, this.automationTag('next')),
          _react2.default.createElement('i', { className: 'pcty-pager-icon-next' })
        );
      }

      if (page < pageCount) {
        return _react2.default.createElement(
          'a',
          _extends({ className: 'pcty-pager-control', onClick: function onClick() {
              return _this4.goForwardAPage();
            }, title: 'Go to the next page' }, this.automationTag('next')),
          _react2.default.createElement('i', { className: 'pcty-pager-icon-next' })
        );
      }
    }
  }, {
    key: 'renderLast',
    value: function renderLast() {
      var _this5 = this;

      var itemCount = this.props.itemCount;
      var pageCount = this.state.pageCount;


      if (itemCount <= 0) return null;

      var page = this.state.page;


      if (page === pageCount || this.props.disabled) {
        return _react2.default.createElement(
          'a',
          _extends({ className: 'pcty-pager-control pcty-disabled', title: 'Go to the last page' }, this.automationTag('last')),
          _react2.default.createElement('i', { className: 'pcty-pager-icon-last' })
        );
      }

      if (page < pageCount) {
        return _react2.default.createElement(
          'a',
          _extends({ className: 'pcty-pager-control', onClick: function onClick() {
              return _this5.goToLastPage();
            }, title: 'Go to the last page' }, this.automationTag('last')),
          _react2.default.createElement('i', { className: 'pcty-pager-icon-last' })
        );
      }
    }
  }, {
    key: 'renderPageRange',
    value: function renderPageRange() {
      var _props = this.props,
          disabled = _props.disabled,
          itemCount = _props.itemCount,
          pageSize = _props.pageSize;
      var pageCount = this.state.pageCount;


      var css = 'pcty-pager-info' + (disabled ? ' pcty-disabled' : '');

      if (pageCount <= 0) {
        return _react2.default.createElement(
          'span',
          { className: css },
          _react2.default.createElement(
            'span',
            this.automationTag('totalcount'),
            '0'
          ),
          ' items'
        );
      }

      var page = this.state.page;


      return _react2.default.createElement(
        'span',
        { className: css },
        _react2.default.createElement(
          'span',
          this.automationTag('pagestart'),
          this.getPageRangeStart(itemCount, pageCount, pageSize, page)
        ),
        ' - ',
        _react2.default.createElement(
          'span',
          this.automationTag('pageend'),
          this.getPageRangeEnd(itemCount, pageCount, pageSize, page)
        ),
        ' of ',
        _react2.default.createElement(
          'span',
          this.automationTag('totalcount'),
          itemCount
        ),
        ' items'
      );
    }
  }, {
    key: 'renderPageLinks',
    value: function renderPageLinks() {
      var _this6 = this;

      var _props2 = this.props,
          disabled = _props2.disabled,
          id = _props2.id,
          itemCount = _props2.itemCount,
          numberOfVisiblePages = _props2.numberOfVisiblePages;
      var pageCount = this.state.pageCount;


      if (itemCount <= 0) return null;

      var page = this.state.page;

      var visiblePages = this.getVisiblePages(numberOfVisiblePages, page, pageCount);

      if (disabled) {
        return visiblePages.map(function (x, index) {
          return _react2.default.createElement(
            'li',
            { className: 'pcty-item', key: 'pcty-item-' + id + '-' + index },
            _react2.default.createElement(
              'a',
              _extends({ className: 'pcty-target pcty-disabled' }, _this6.automationTag('page' + x)),
              x
            )
          );
        });
      }

      return visiblePages.map(function (x, index) {
        return _react2.default.createElement(
          'li',
          { className: x === page ? 'pcty-item pcty-active' : 'pcty-item', key: 'pcty-item-' + id + '-' + index },
          x === page ? x : _react2.default.createElement(
            'a',
            _extends({ className: 'pcty-target', onClick: function onClick() {
                return _this6.goToPage(id, x);
              } }, _this6.automationTag('page' + x)),
            x
          )
        );
      });
    }
  }, {
    key: 'renderBackElipses',
    value: function renderBackElipses() {
      var _this7 = this;

      var _props3 = this.props,
          disabled = _props3.disabled,
          itemCount = _props3.itemCount,
          numberOfVisiblePages = _props3.numberOfVisiblePages;
      var pageCount = this.state.pageCount;


      if (itemCount <= 0) return null;

      var page = this.state.page;

      var visiblePages = this.getVisiblePages(numberOfVisiblePages, page, pageCount);

      if (disabled) {
        return visiblePages.indexOf(1) === -1 ? _react2.default.createElement(
          'li',
          { className: 'pcty-item' },
          _react2.default.createElement(
            'a',
            _extends({ className: 'pcty-target pcty-disabled' }, this.automationTag('prevrange')),
            '...'
          )
        ) : null;
      }

      return visiblePages.indexOf(1) === -1 ? _react2.default.createElement(
        'li',
        { className: 'pcty-item' },
        _react2.default.createElement(
          'a',
          _extends({ className: 'pcty-target', onClick: function onClick() {
              return _this7.goBackAPageRange();
            } }, this.automationTag('prevrange')),
          '...'
        )
      ) : null;
    }
  }, {
    key: 'renderForwardElipses',
    value: function renderForwardElipses() {
      var _this8 = this;

      var _props4 = this.props,
          disabled = _props4.disabled,
          itemCount = _props4.itemCount,
          numberOfVisiblePages = _props4.numberOfVisiblePages;
      var pageCount = this.state.pageCount;


      if (itemCount <= 0) return null;

      var page = this.state.page;

      var visiblePages = this.getVisiblePages(numberOfVisiblePages, page, pageCount);

      if (disabled) {
        return visiblePages.indexOf(pageCount) === -1 ? _react2.default.createElement(
          'li',
          { className: 'pcty-item' },
          _react2.default.createElement(
            'a',
            _extends({ className: 'pcty-target pcty-disabled' }, this.automationTag('nextrange')),
            '...'
          )
        ) : null;
      }

      return visiblePages.indexOf(pageCount) === -1 ? _react2.default.createElement(
        'li',
        { className: 'pcty-item' },
        _react2.default.createElement(
          'a',
          _extends({ className: 'pcty-target', onClick: function onClick() {
              return _this8.goForwardAPageRange();
            } }, this.automationTag('nextrange')),
          '...'
        )
      ) : null;
    }
  }, {
    key: 'getPageRangeStart',
    value: function getPageRangeStart(itemCount, pageCount, pageSize, page) {
      if (itemCount <= 0) return 0;

      return pageCount > 0 ? page * pageSize - (pageSize - 1) : 0;
    }
  }, {
    key: 'getPageRangeEnd',
    value: function getPageRangeEnd(itemCount, pageCount, pageSize, page) {
      if (itemCount <= 0) return 0;

      return page === pageCount ? itemCount - (pageSize - 1) * page + (pageSize - 1) * page : page * pageSize;
    }
  }, {
    key: 'getVisiblePages',
    value: function getVisiblePages(numberOfVisiblePages, page, pageCount) {
      if (!page) return [];

      var numberOfVisible = numberOfVisiblePages;
      var min = page % numberOfVisible === 0 ? page - (numberOfVisible - 1) : page - page % numberOfVisible + 1;
      var pages = new Array(numberOfVisible + 1).join('0').split('').map(function (x, i) {
        return min + i;
      });

      var ret = pages.filter(function (x) {
        return x <= pageCount;
      });

      return this.handleRemainder(ret, numberOfVisible);
    }
  }, {
    key: 'handleRemainder',
    value: function handleRemainder(pages, numberOfVisible) {
      if (!pages.length || pages.length && pages.length === numberOfVisible) return pages;

      var temp = [];
      var numberMissing = numberOfVisible - pages.length;

      new Array(numberMissing).join('0').split('').forEach(function (x, i) {
        var backfill = pages[0] - numberMissing + i;
        if (backfill > 0) {
          temp.push(backfill);
        }
      });

      pages.forEach(function (x) {
        return temp.push(x);
      });

      return temp;
    }
  }, {
    key: 'goToFirstPage',
    value: function goToFirstPage() {
      var _this9 = this;

      var _props5 = this.props,
          id = _props5.id,
          numberOfVisiblePages = _props5.numberOfVisiblePages;

      var start = 1;
      var visiblePages = Array.from({ length: numberOfVisiblePages }, function (v, k) {
        return k + start;
      });

      this.setState({ visiblePages: visiblePages }, function () {
        return _this9.goToPage(id, 1);
      });
    }
  }, {
    key: 'goToLastPage',
    value: function goToLastPage() {
      var _this10 = this;

      var _props6 = this.props,
          id = _props6.id,
          numberOfVisiblePages = _props6.numberOfVisiblePages;
      var pageCount = this.state.pageCount;

      var start = pageCount;
      var visiblePages = Array.from({ length: numberOfVisiblePages }, function (v, k) {
        return k + start;
      });

      this.setState({ visiblePages: visiblePages }, function () {
        return _this10.goToPage(id, pageCount);
      });
    }
  }, {
    key: 'goBackAPage',
    value: function goBackAPage() {
      var _props7 = this.props,
          id = _props7.id,
          numberOfVisiblePages = _props7.numberOfVisiblePages;
      var pageCount = this.state.pageCount;
      var page = this.state.page;

      var currentRange = this.getVisiblePages(numberOfVisiblePages, page, pageCount);

      if (currentRange[0] === page) {
        return this.goBackAPageRange();
      }

      this.goToPage(id, page - 1);
    }
  }, {
    key: 'goForwardAPage',
    value: function goForwardAPage() {
      var _props8 = this.props,
          id = _props8.id,
          numberOfVisiblePages = _props8.numberOfVisiblePages;
      var pageCount = this.state.pageCount;
      var page = this.state.page;

      var currentRange = this.getVisiblePages(numberOfVisiblePages, page, pageCount);

      if (currentRange[currentRange - 1] === page) {
        return this.goForwardAPageRange();
      }

      this.goToPage(id, page + 1);
    }
  }, {
    key: 'goBackAPageRange',
    value: function goBackAPageRange() {
      var _this11 = this;

      var _props9 = this.props,
          id = _props9.id,
          numberOfVisiblePages = _props9.numberOfVisiblePages;
      var pageCount = this.state.pageCount;

      var currentRange = this.getVisiblePages(numberOfVisiblePages, this.state.page, pageCount);

      var start = currentRange[0] - this.props.numberOfVisiblePages;
      start = start > 0 ? start : 1;

      var visiblePages = Array.from({ length: this.props.numberOfVisiblePages }, function (v, k) {
        return k + start;
      });
      this.setState({ visiblePages: visiblePages }, function () {
        return _this11.goToPage(id, visiblePages[visiblePages.length - 1]);
      });
    }
  }, {
    key: 'goForwardAPageRange',
    value: function goForwardAPageRange() {
      var _this12 = this;

      var _props10 = this.props,
          id = _props10.id,
          numberOfVisiblePages = _props10.numberOfVisiblePages;
      var pageCount = this.state.pageCount;

      var currentRange = this.getVisiblePages(numberOfVisiblePages, this.state.page, pageCount);

      var start = currentRange[numberOfVisiblePages - 1] + 1;
      start = start < pageCount ? start : pageCount;

      var end = start + numberOfVisiblePages;
      end = end <= pageCount ? end : pageCount;

      var visiblePages = Array.from({ length: end - start + 1 }, function (v, k) {
        return k + start;
      });
      this.setState({ visiblePages: visiblePages }, function () {
        return _this12.goToPage(id, currentRange[numberOfVisiblePages - 1] + 1);
      });
    }
  }, {
    key: 'goToPage',
    value: function goToPage(id, page) {
      var _this13 = this;

      this.setState({ page: page }, function () {
        return _this13.props.onClickGoToPage(id, page);
      });
    }
  }, {
    key: 'automationTag',
    value: function automationTag(targetName) {
      if (this.props.automationId) {
        return { 'data-automation-id': this.props.automationId + '-' + targetName };
      }
      return {};
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (state.stateUpdate) {
        return _extends({}, state, {
          stateUpdate: false,
          props: props
        });
      }

      var newProps = {};

      if (props.page !== state.props.page) {
        newProps = {
          page: props.page,
          props: props
        };
      }

      if (props.itemCount !== state.props.itemCount || props.pageSize !== state.props.pageSize) {
        newProps = _extends({}, newProps, {
          page: props.page,
          pageCount: calcPageCount(props.itemCount, props.pageSize),
          props: props
        });
      }

      if (Object.keys(newProps).length > 0) {
        return newProps;
      }

      return null;
    }
  }]);

  return PctyPager;
}(_react.Component);

var calcPageCount = function calcPageCount(itemCount, pageSize) {
  if (itemCount % pageSize === 0) {
    return parseInt(itemCount / pageSize);
  }

  return parseInt(itemCount / pageSize) + 1;
};

PctyPager.propTypes = {
  /** ID for component. */
  id: _propTypes2.default.string.isRequired,
  /** Total number of items. */
  itemCount: _propTypes2.default.number.isRequired,
  /** Number of items shown on each page */
  pageSize: _propTypes2.default.number.isRequired,
  /** Default page to start with. */
  page: _propTypes2.default.number.isRequired,
  /** Determines amount of page to show before ellipses. */
  numberOfVisiblePages: _propTypes2.default.number,
  /** { description: "Action triggered when clicking on a page.", validValues: "any function with (id, page) as named params" } */
  onClickGoToPage: _propTypes2.default.func.isRequired,
  /** Whether or not the component is disabled */
  disabled: _propTypes2.default.bool,
  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes2.default.string,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation2.default)(props, propName, componentName, 'PctyPager');
  }
};

PctyPager.defaultProps = {
  numberOfVisiblePages: 5,
  disabled: false,
  __TYPE: 'PctyPager'
};

exports.default = PctyPager;